import { ArrowRight } from "lucide-react";
import bg2 from "../../assets/images/gallery/1.webp";

export default function Hero() {
  return (
    <section
      className="
        relative flex items-center justify-center overflow-hidden
        h-[90vh] sm:h-[85vh] md:min-h-screen
      "
      style={{
        backgroundImage: `url(${bg2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[#07162E]/85 md:bg-[#07162E]/80"></div>

      {/* Animated gradient overlay */}
      <div
        className="absolute inset-0 bg-gradient-to-r
        from-[#0E6F7E]/25 via-transparent to-[#1DBF73]/20
        animate-gradient-x"
      ></div>

      {/* Grid pattern overlay */}
      <div
        className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')]
        opacity-15 md:opacity-20"
      ></div>

      {/* Floating orbs – desktop only */}
      <div className="hidden md:block absolute top-20 left-20 w-72 h-72 bg-[#1DBF73]/20 rounded-full blur-3xl animate-float-slow"></div>
      <div className="hidden md:block absolute bottom-20 right-20 w-96 h-96 bg-[#0E6F7E]/30 rounded-full blur-3xl animate-float-reverse"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-5 sm:px-8 md:px-12 text-center">
        <div className="max-w-5xl mx-auto space-y-5 sm:space-y-6 md:space-y-8">
          
          {/* Headline */}
          <h1 className="font-bold text-white leading-tight tracking-tight">
            <span className="block text-3xl sm:text-4xl md:text-6xl lg:text-7xl animate-title">
              Partner Program & Masterclass for
            </span>
            <span className="block text-transparent bg-clip-text
              bg-gradient-to-r from-[#1DBF73] to-[#4FD1C5]
              text-3xl sm:text-4xl md:text-6xl lg:text-7xl
              animate-title-delay">
              Investment Professionals
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-sm sm:text-base md:text-2xl text-gray-200 font-light animate-fade-slide delay-200">
            A Strategic Program for Capital Market & Investment Experts
          </p>

          {/* Description – hidden on very small screens */}
          <p className="hidden sm:block text-sm sm:text-base md:text-lg text-gray-300 max-w-3xl mx-auto animate-fade-slide delay-400">
            Empower professionals with structured investment frameworks,
            institutional alignment, and long-term capital collaboration.
          </p>

          {/* CTA */}
          <div className="pt-4 sm:pt-6 md:pt-10 animate-fade-slide delay-600 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            {/* <a
              href="https://nexthappen.com/event/50/aqt-direct-partners-meet"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            > */}
              <button
                className="
                  group px-8 sm:px-12 py-3 sm:py-4
                  bg-gradient-to-r from-[#1DBF73] to-[#0E6F7E]
                  text-white font-semibold
                  rounded-full
                  shadow-[0_0_30px_rgba(29,191,115,0.45)]
                  hover:shadow-[0_0_50px_rgba(29,191,115,0.65)]
                  transition-all duration-300
                  hover:-translate-y-1 hover:scale-105
                  flex items-center gap-3 text-base sm:text-lg
                "
              >
                Apply For Partnership
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
              </button>
            {/* </a> */}

            {/* <a
              href="https://forms.gle/yS12N6YnnmRH8rG37"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <button
                className="
                  group px-8 sm:px-12 py-3 sm:py-4
                  bg-gradient-to-r from-[#D4AF37] via-[#F4E4A6] to-[#C9A631]
                  text-[#07162E] font-semibold
                  rounded-full
                  shadow-[0_0_30px_rgba(212,175,55,0.45)]
                  hover:shadow-[0_0_50px_rgba(212,175,55,0.65)]
                  transition-all duration-300
                  hover:-translate-y-1 hover:scale-105
                  flex items-center gap-3 text-base sm:text-lg
                  animate-blink
                "
              >
                Are You Interested? 
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
              </button>
            </a> */}
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 md:h-32 bg-gradient-to-t from-[#07162E] to-transparent"></div>

      {/* Animations */}
      <style>{`
        @keyframes gradient-x {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(-25%); }
        }
        .animate-gradient-x {
          animation: gradient-x 18s ease-in-out infinite;
        }

        @keyframes floatSlow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-30px); }
        }
        .animate-float-slow {
          animation: floatSlow 14s ease-in-out infinite;
        }

        @keyframes floatReverse {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(30px); }
        }
        .animate-float-reverse {
          animation: floatReverse 16s ease-in-out infinite;
        }

        @keyframes titleReveal {
          from { opacity: 0; transform: translateY(50px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-title {
          animation: titleReveal 1s ease-out forwards;
        }
        .animate-title-delay {
          animation: titleReveal 1s ease-out forwards;
          animation-delay: 0.2s;
        }

        @keyframes fadeSlide {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-slide {
          opacity: 0;
          animation: fadeSlide 0.9s ease-out forwards;
        }
        .delay-200 { animation-delay: 0.2s; }
        .delay-400 { animation-delay: 0.4s; }
        .delay-600 { animation-delay: 0.6s; }
      `}</style>
    </section>
  );
}
